import { PlayerAnalytics } from '../lib/analytics'

export default class Analytics {
  private playerAnalytics: PlayerAnalytics | null = null
  private videoElt: HTMLVideoElement

  constructor(videoElt: HTMLVideoElement) {
    this.videoElt = videoElt
  }

  observeMedia(mediaId: string, collectorDomain: string) {
    const newPingUrl = this.formatPingUrl(collectorDomain)

    if (this.playerAnalytics) {
      const parameters = this.playerAnalytics.getParameters()
      if (newPingUrl !== parameters.pingUrl) {
        this.restartObserveMedia(mediaId, newPingUrl)
      } else if (mediaId !== parameters.mediaId) {
        this.updateObserveMedia(mediaId)
      }
    } else {
      this.startObserveMedia(mediaId, newPingUrl)
    }
  }

  private startObserveMedia(mediaId: string, pingUrl: string) {
    this.playerAnalytics = new PlayerAnalytics({
      mediaId,
      pingUrl,
    })
    this.playerAnalytics.ovbserveMedia(this.videoElt)
  }

  private restartObserveMedia(mediaId: string, pingUrl: string) {
    this.playerAnalytics?.dispose()
    this.startObserveMedia(mediaId, pingUrl)
  }

  private updateObserveMedia(mediaId: string) {
    this.playerAnalytics?.updateMediaId(mediaId)
  }

  private formatPingUrl(collectorDomain: string) {
    return `https://${collectorDomain}/event`
  }
}
